import { DeleteOutline as DeleteOutlinedIcon } from '@mui/icons-material';
import { Menu } from 'src/components/menu';
import { lang } from 'src/utils';

import { ProductVariationMenuProps } from './ProductVariationMenu.interface';

export const ProductVariationMenu = (props: ProductVariationMenuProps) => {
  const onDeleteClick = async () => {
    props.onDeleteClick();
    props.onClose();
  };

  const productPosition = props.index === 0 && props.productVariationsCount > 1;
  const tooltip = lang.productVariationValidation;
  const items = [
    {
      label: lang.productVariationDelete,
      onClick: onDeleteClick,
      leftIcon: <DeleteOutlinedIcon color="error" />,
      disabled: productPosition,
      productVariation: true,
      tooltip: tooltip,
    },
  ];

  return (
    <Menu anchorEl={props.anchorEl} items={items} onClose={props.onClose} />
  );
};
